import React, { useState } from 'react';
import { Box, Tabs, Tab, Stack } from '@mui/material';
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";

export const TabWithIndependentButtons = ({
  tabs = [],
  buttons = [],
  buttonProps = {},
  activeTab, setActiveTab
}) => {

  return (
    <Box sx={{
      width: '100%',
      borderBottom: 1,
      borderColor: 'divider',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingX: 2,
      p:"none"
    }}>
      <Box sx={{ flexGrow: 1 }}>
        <Tabs
           value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="bodyMedium"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: 'var(--green-100)',
              height: 3
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              minWidth: 'unset',
              padding: '2px 16px',
              '&.Mui-selected': {
                color: 'var(--brand-910)',
                fontWeight: 600
              },
              '&:hover': {
                color: 'var(--brand-910)'
              },
              '&.Mui-disabled': {
                opacity: 0.5,
                pointerEvents: 'none'
              }
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={`tab-${index}`}
              label={tab.label}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>

      {buttons.length > 0 && (
        <Stack direction="row" spacing={1} sx={{ ml: 2 }}>
          {buttons.map((button, index) => (
            <OutLinedButton
              startAdornment={button.startAdornment}
              key={`btn-${index}`}
              {...button}
              {...buttonProps}
              sx={{
                ...button?.sx
              }}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
};
